import { Action } from '@ngrx/store';
import {SelfServiceAgreement, SelfServiceEsignForm } from '@model';

export enum AgreementActionTypes {
  AgreementLinkLoad = '[SelfServiceAgreement] Link Load',
  AgreementLinkLoadSuccess = '[SelfServiceAgreement] Link Load Success',
  AgreementLinkLoadFail = '[SelfServiceAgreement] Link Load Fail',
  SelfServiceAgreementsLoad = '[SelfServicegreements] Load data',
  SelfServiceAgreementsLoadSuccess = '[SelfServicegreements] Load success',
  SelfServiceAgreementsLoadFail = '[SelfServiceAgreements] Load fail',
  CreateSelfServiceAgreement = '[SelfServiceAgreement] create e-signature selfservice agreement',
  CreateSelfServiceAgreementSuccess = '[SelfServiceAgreement] create e-signature selfservice agreement success',
  CreateSelfServiceAgreementFail = '[SelfServiceAgreement] create e-signature selfservice agreement fail'
}

export class AgreementLinkLoad implements Action {
    readonly type = AgreementActionTypes.AgreementLinkLoad;
    constructor(public agreementId: number) {}
}

export class AgreementLinkLoadSuccess implements Action {
    readonly type = AgreementActionTypes.AgreementLinkLoadSuccess;
    constructor(public payload: string) {}
}

export class AgreementLinkLoadFail implements Action {
    readonly type = AgreementActionTypes.AgreementLinkLoadFail;
    constructor(public payload: any) {}
}

export class SelfServiceAgreementsLoad implements Action {
  readonly type = AgreementActionTypes.SelfServiceAgreementsLoad;
  constructor() {}
}

export class SelfServiceAgreementsLoadSuccess implements Action {
  readonly type = AgreementActionTypes.SelfServiceAgreementsLoadSuccess;
  constructor(public payload: SelfServiceAgreement[]) {}
}
export class SelfServiceAgreementsLoadFail implements Action {
  readonly type = AgreementActionTypes.SelfServiceAgreementsLoadFail;
  constructor(public payload: any) {}
}

export class CreateSelfServiceAgreement implements Action {
  readonly type = AgreementActionTypes.CreateSelfServiceAgreement;
  constructor(public payload: SelfServiceEsignForm) {}
}

export class CreateSelfServiceAgreementSuccess implements Action {
  readonly type = AgreementActionTypes.CreateSelfServiceAgreementSuccess;
  constructor(public payload: number) {}
}

export class CreateSelfServiceAgreementFail implements Action {
  readonly type = AgreementActionTypes.CreateSelfServiceAgreementFail;
  constructor(public payload: any) {}
}

export type AgreementActions = 
    | AgreementLinkLoad
    | AgreementLinkLoadSuccess
    | AgreementLinkLoadFail
    | SelfServiceAgreementsLoad
    | SelfServiceAgreementsLoadSuccess
    | SelfServiceAgreementsLoadFail
    | CreateSelfServiceAgreement
    | CreateSelfServiceAgreementSuccess
    | CreateSelfServiceAgreementFail;